<template lang="pug">
  b-nav-item-dropdown(right no-caret)
    template(slot="button-content")
      i.flag-icon(:class="{ 'flag-icon-us' : getLanguage == 'en', 'flag-icon-cn' : getLanguage == 'zh' }")
      small.fa.fa-caret-down.ml-1
    b-dropdown-header.text-center(tag="div")
      strong {{ $t("language.selection") }}
    b-dropdown-item(:class="{ 'active': getLanguage == 'en' }" @click="setLanguage('en')")
      i.flag-icon.flag-icon-us
      span {{ $t("language.english") }}
    b-dropdown-item(:class="{ 'active': getLanguage == 'zh' }" @click="setLanguage('zh')")
      i.flag-icon.flag-icon-cn
      span {{ $t("language.simplified_chinese") }}
</template>

<script>
export default {
  computed: {
    getLanguage() {
      return this.$store.getters.language;
    }
  },
  methods: {
    setLanguage(payload) {
      this.$store.dispatch("layout/setLanguage", payload);
    }
  }
};
</script>
